/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Response body fields which will be returned while fetching the list of country's regions.
 * @export
 * @interface Region
 */
export interface Region {
    /**
     * Country and Region code in iso format
     * @type {string}
     * @memberof Region
     */
    isocode?: string;
    /**
     * Region code in short iso form
     * @type {string}
     * @memberof Region
     */
    isocodeShort?: string;
    /**
     * Country code in iso format
     * @type {string}
     * @memberof Region
     */
    countryIso?: string;
    /**
     * Name of the region
     * @type {string}
     * @memberof Region
     */
    name?: string;
}

/**
 * Check if a given object implements the Region interface.
 */
export function instanceOfRegion(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RegionFromJSON(json: any): Region {
    return RegionFromJSONTyped(json, false);
}

export function RegionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Region {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isocode': !exists(json, 'isocode') ? undefined : json['isocode'],
        'isocodeShort': !exists(json, 'isocodeShort') ? undefined : json['isocodeShort'],
        'countryIso': !exists(json, 'countryIso') ? undefined : json['countryIso'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function RegionToJSON(value?: Region | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isocode': value.isocode,
        'isocodeShort': value.isocodeShort,
        'countryIso': value.countryIso,
        'name': value.name,
    };
}

